export default __webpack_public_path__ + "static/media/dr_moran_brouk.949dcd3e.jpg";